// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AboutPopup__container-aeee23 {
  overflow: auto;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.AboutPopup__info-fd5df2 {
  align-items: center;
  display: flex;
  flex-direction: column;
  padding: 24px;
}

.AboutPopup__logo-da4751 {
  width: 104px;
  height: 104px;
  margin-bottom: 24px;
}

.AboutPopup__title-da3755 {
  color: var(--base-110);
  font: var(--font-title-5);
  letter-spacing: var(--font-spacing-title-5);
}

.AboutPopup__version-c724c7 {
  color: var(--base-80);
  font: var(--font-body-4);
  letter-spacing: var(--font-spacing-body-4);
}

.AboutPopup__list-item-dfd1bb {
  padding: 0 24px;
  height: 48px;
}

.AboutPopup__copyright-d1c8b9 {
  text-align: center;
  font: var(--font-subtitle-4);
  letter-spacing: var(--font-spacing-subtitle-4);
  color: var(--base-80);
  padding: 16px;
  margin-top: auto;
}`, "",{"version":3,"sources":["webpack://./src/main/PopupManager/Popups/AboutPopup/AboutPopup.styles.m.css"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AACF;;AAEA;EACE,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;AACF;;AAEA;EACE,YAAA;EACA,aAAA;EACA,mBAAA;AACF;;AAEA;EACE,sBAAA;EACA,yBAAA;EACA,2CAAA;AACF;;AAEA;EACE,qBAAA;EACA,wBAAA;EACA,0CAAA;AACF;;AAEA;EACE,eAAA;EACA,YAAA;AACF;;AAEA;EACE,kBAAA;EACA,4BAAA;EACA,8CAAA;EACA,qBAAA;EACA,aAAA;EACA,gBAAA;AACF","sourcesContent":[".container {\n  overflow: auto;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n.info {\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  padding: 24px;\n}\n\n.logo {\n  width: 104px;\n  height: 104px;\n  margin-bottom: 24px;\n}\n\n.title {\n  color: var(--base-110);\n  font: var(--font-title-5);\n  letter-spacing: var(--font-spacing-title-5);\n}\n\n.version {\n  color: var(--base-80);\n  font: var(--font-body-4);\n  letter-spacing: var(--font-spacing-body-4);\n}\n\n.list-item {\n  padding: 0 24px;\n  height: 48px;\n}\n\n.copyright {\n  text-align: center;\n  font: var(--font-subtitle-4);\n  letter-spacing: var(--font-spacing-subtitle-4);\n  color: var(--base-80);\n  padding: 16px;\n  margin-top: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `AboutPopup__container-aeee23`,
	"info": `AboutPopup__info-fd5df2`,
	"logo": `AboutPopup__logo-da4751`,
	"title": `AboutPopup__title-da3755`,
	"version": `AboutPopup__version-c724c7`,
	"list-item": `AboutPopup__list-item-dfd1bb`,
	"listItem": `AboutPopup__list-item-dfd1bb`,
	"copyright": `AboutPopup__copyright-d1c8b9`
};
module.exports = ___CSS_LOADER_EXPORT___;
